// Shared option lists + i18n keys for the "questions" field type, used by both the edit-mode
// repeater (QuestionsField) and the read-only view (ResourceView) so labels stay in sync.

export const ANSWER_TYPES = ["numeric", "text", "photo", "dropdown", "date", "boolean"];
export const ANSWER_TYPE_LABELS = {
  numeric: "answer_numeric",
  text: "answer_text",
  photo: "answer_photo",
  dropdown: "answer_dropdown",
  date: "answer_date",
  boolean: "answer_boolean",
};

export const PRIORITIES = [0, 1, 2];
export const PRIORITY_LABELS = { 0: "priority_low", 1: "priority_medium", 2: "priority_high" };

export const QUESTION_MODES = ["products", "brands", "categories", "subcategories"];
export const QUESTION_MODE_LABELS = {
  products: "mode_products",
  brands: "mode_brands",
  categories: "mode_categories",
  subcategories: "mode_subcategories",
};

export const PRODUCTS_SOURCES = ["all", "assortment_matrix"];
export const PRODUCTS_SOURCE_LABELS = { all: "source_all", assortment_matrix: "source_assortment_matrix" };

// Per-entity targeting groups a question can scope itself to (products/brands/categories/subcategories).
export const TARGETING_GROUPS = [
  { key: "products", allKey: "all_products", entity: "products", labelKey: "f_products", allLabelKey: "f_all_products" },
  { key: "brands", allKey: "all_brands", entity: "brands", labelKey: "f_brands", allLabelKey: "f_all_brands" },
  { key: "categories", allKey: "all_categories", entity: "categories", labelKey: "f_categories", allLabelKey: "f_all_categories" },
  { key: "subcategories", allKey: "all_subcategories", entity: "subcategories", labelKey: "f_subcategories", allLabelKey: "f_all_subcategories" },
];

export const AUDIENCE_TARGET_TYPES = [
  { key: "points", entity: "point", labelKey: "target_points" },
  { key: "point_groups", entity: "point_groups", labelKey: "target_point_groups" },
  { key: "networks", entity: "networks", labelKey: "target_networks" },
];
